<template>
	<div class="mia-SiteContactTypeForm panel panel-default">
		<div class="panel-heading">
			<h3 class="panel-title">
				{{ $tr('PopupContactTitle') }}
			</h3>
		</div>
		<div class="panel-body">
			<template v-if="isChild">
				<template v-if="isLoggedIn">
					<h1 v-tr="'PopupContact_loggedIn_children_title'" />
					<p v-tr="{ key: 'PopupContact_loggedIn_children', chatSupportLink: chatSupportLink }" class="mia-SiteContactTypeForm-paragraph" />
				</template>
				<template v-else>
					<h1 v-tr="'PopupContact_help_title'" />
					<p v-tr="'PopupContact_children'" class="mia-SiteContactTypeForm-paragraph" />
				</template>
			</template>
			<template v-else>
				<h1 v-tr="'PopupContact_help_title'" class="mia-SiteContactTypeForm-title" />
				<p v-tr="isLoggedIn ? 'PopupContact_loggedIn_parents' : 'PopupContact_parents'" class="mia-SiteContactTypeForm-paragraph" />
				<div ref="typeformEmbed" data-tf-live="01JKE5GNDRPRGEFJYWQF35ZEKP" />
			</template>
		</div>
	</div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from 'vue-facing-decorator';

@Component
export class SiteContactTypeForm extends Vue {
	@Prop({ required: true, type: Boolean }) isLoggedIn!: boolean;
	@Prop({ required: true, type: Boolean }) isChild!: boolean;
	@Prop({ required: false, type: String, default: null }) chatSupportLink!: string | null;

	mounted(): void {
		if (this.$refs.typeformEmbed) {
			const script: HTMLScriptElement = document.createElement('script');
			script.src = "//embed.typeform.com/next/embed.js";
			script.async = false;
			(this.$refs.typeformEmbed as HTMLElement).parentElement?.appendChild(script);
		}
	}
}

export default toNative(SiteContactTypeForm);
</script>
<style lang="scss">
.mia-SiteContactTypeForm {
	margin-top: theme.$mia-margin-size-xl;

	.mia-SiteContactTypeForm-paragraph {
		margin-top: theme.$mia-margin-size-md;
	}
}
</style>
